import React, { useRef } from "react";
import { Upload, X, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { fileToBase64 } from "@/lib/utils-app";

export default function SiteImageField({
  label = "Imagen",
  value,
  onChange,
  previewVariant = "banner",
}) {
  const fileRef = useRef(null);

  const previewWrap =
    previewVariant === "logo"
      ? "flex justify-center items-center bg-white/5 rounded-sm p-4 min-h-[120px] border border-white/10"
      : previewVariant === "hero"
        ? "rounded-sm overflow-hidden bg-white/5 aspect-[21/9] max-h-40 border border-white/10"
        : "rounded-sm overflow-hidden bg-white/5 aspect-video max-h-40 border border-white/10";

  const imgClass =
    previewVariant === "logo"
      ? "max-h-24 max-w-full object-contain"
      : "w-full h-full object-cover";

  const pickFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Selecciona una imagen");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Máximo 5 MB");
      return;
    }
    try {
      onChange(await fileToBase64(file));
      toast.success("Imagen cargada");
    } catch {
      toast.error("No se pudo leer la imagen");
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="text-xs uppercase tracking-widest text-white/60">{label}</span>
        <div className="flex gap-2">
          <button type="button" onClick={() => fileRef.current?.click()} className="btn-outline text-xs py-1.5">
            <Upload size={12} /> Subir
          </button>
          {value && (
            <button type="button" onClick={() => onChange(null)} className="btn-outline text-xs py-1.5 text-red-400 border-red-400/30">
              <X size={12} /> Quitar
            </button>
          )}
        </div>
      </div>
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={pickFile} />
      <div className={previewWrap}>
        {value ? (
          <img src={value} alt="" className={imgClass} />
        ) : (
          <div className="flex flex-col items-center gap-2 text-white/40 py-6">
            <ImageIcon size={28} />
            <span className="text-xs">Sin imagen</span>
          </div>
        )}
      </div>
    </div>
  );
}
